import { createStore, applyMiddleware, compose } from "redux";
import createHistory from "history/createBrowserHistory";
import thunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";

import rootReducer from "./reducers/index";

// Data
import products from "./data/products";
import industries from "./data/industries";
import appetites from "./data/appetites";
import resources from "./data/resources";
import contacts from "./data/contacts";

const defaultState = {
    industries,
    products,
    appetites,
    resources,
    contacts
};

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    defaultState,
    composeEnhancers(applyMiddleware(thunk, middleware))
);

export { history };

export default store;



// WEBPACK FOOTER //
// ./src/store.js